import * as React from 'react';

const CalendarCheckMarkChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="calendar-check-mark-chunky_svg__eds-icon--ticket-fill-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <g>
            <g>
                <path
                    id="calendar-check-mark-chunky_svg__SVGID_1_"
                    d="M16.3 18.4l2.9-2.9-.9-.9-2.1 2.1-.7-.8-.8.8 1.6 1.7zm.6-5.9c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zm2-1h-2v-1h-10v7h4v2h-6v-13h2v-2h2v2h6v-2h2v2h2v5z"
                />
            </g>
        </g>
    </svg>
);

CalendarCheckMarkChunkySvg.displayName = 'CalendarCheckMarkChunkySvg';
export default CalendarCheckMarkChunkySvg;
